import { useEffect, useRef, useState } from "react";
import { UploadSimple, Buildings } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { API, formatApiError } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

export default function BrandingPanel() {
  const [name, setName] = useState("");
  const [hasLogo, setHasLogo] = useState(false);
  const [bust, setBust] = useState(Date.now());
  const fileRef = useRef();

  useEffect(() => {
    api.get("/branding").then((r) => { setName(r.data.company_name); setHasLogo(r.data.has_logo); });
  }, []);

  const saveName = async () => {
    try { await api.put("/branding", { company_name: name }); toast.success("Nombre actualizado"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try {
      await api.post("/branding/logo", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setHasLogo(true); setBust(Date.now());
      toast.success("Logo subido");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <div className="max-w-2xl">
      <h2 className="font-heading text-3xl font-extrabold uppercase mb-6">Marca de tu empresa</h2>

      <div className="bg-[#131417] border border-white/10 p-6 space-y-6">
        <div>
          <label className="text-xs tracking-widest uppercase text-muted-foreground flex items-center gap-1 mb-2"><Buildings size={14} /> Nombre que se muestra en pantalla</label>
          <div className="flex gap-3">
            <Input data-testid="company-name-input" value={name} onChange={(e) => setName(e.target.value)} className="bg-[#0A0A0C] border-white/15" />
            <Button data-testid="save-company-name-btn" onClick={saveName} className="bg-padel-blue text-black font-heading uppercase tracking-widest rounded-none shrink-0">Guardar</Button>
          </div>
        </div>

        <div>
          <p className="text-xs tracking-widest uppercase text-muted-foreground mb-2">Logo</p>
          <div className="flex items-center gap-5">
            <div className="w-32 h-32 border border-white/10 bg-[#0A0A0C] flex items-center justify-center overflow-hidden">
              {hasLogo ? (
                <img data-testid="logo-preview" src={`${API}/branding/logo?t=${bust}`} alt="logo" className="w-full h-full object-contain p-2" />
              ) : (
                <span className="text-xs text-muted-foreground">Sin logo</span>
              )}
            </div>
            <div>
              <input ref={fileRef} type="file" accept="image/*" hidden onChange={upload} data-testid="logo-file-input" />
              <Button data-testid="upload-logo-btn" onClick={() => fileRef.current?.click()} className="bg-padel-green text-black font-heading uppercase tracking-widest rounded-none">
                <UploadSimple size={18} className="mr-1" /> Subir logo
              </Button>
              <p className="text-xs text-muted-foreground mt-2">PNG o JPG. Se mostrará en la pantalla pública.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
